export const TRIM_SIZE = {
    TS_6x9: 'TS_6x9',
    TS_8_5x11: 'TS_8_5x11',
    TS_10x8_5: 'TS_10x8_5',
    TS_8x10: 'TS_8x10',
    TS_9_5_8x12: 'TS_9_5_8x12',
    TS_10_5x12: 'TS_10_5x12',
    TS_11x9: 'TS_11x9'
};

export const PAGE_ORIENTATION = {
    LANDSCAPE: 'landscape',
    PORTRAIT: 'portrait'
};

export const LANDSCAPE_PAGE_ORIENTATION = {
    TS_10x8_5: 'TS_10x8_5',
    TS_11x9: 'TS_11x9'
};
export const PORTRAIT_PAGE_ORIENTATION = {
    TS_8_5x11: 'TS_8_5x11',
    TS_6x9: 'TS_6x9',
    TS_10_5x12: 'TS_10_5x12',
    TS_8x10: 'TS_8x10',
    TS_9_5_8x12: 'TS_9_5_8x12'
};

export const DEFAULT_PARENT_DISCIPLINE = {
    id: 'All images',
    name: 'All images'
};

export const OM3P = {
    SEARCH_DATE: 'searchDate',
    ESTIMATED_USERS_COUNT : 'estimatedNumberUsers',
    ISBN : 'assetISBN',
    NO_OF_PAGES : 'noOfPages',
    PAGE_FROM : 'pageFrom',
    PAGE_TO : 'pageTo',
    PAGE_RANGE : 'pageRange',
    RESOURCE_TYPE : 'bookType',
    RESOURCE_TYPE_BOOK : 'EBOOK',
    RESOURCE_TYPE_JOURNAL : 'JOURNAL',
    RESOURCE_TYPE_NEWSPAPER : 'NEWSPAPER',
    RESOURCE_TYPE_WEBSITE : 'WEBSITE',
    RESOURCE_TYPE_IMAGE : 'IMAGE',
    RESOURCE_TYPE_OTHER : 'OTHER',
    RIGHTS_OM : 'OM',
    RIGHTS_3P : 'PearsonRights',
    SOURCE : 'source',
    TITLE : 'title',
    SUB_TITLE : 'subTitle',
    URL : 'url',
    VOLUME_NO : 'volumeEdition',
    YEAR_OF_PUBLICATION : 'publicationYear',
    THIRD_PARTY:'3rd Party Material',
    ORIGINAL_MATERIAL: 'Original Material(OM)',
    CONTENT_TYPE: 'contentType',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    TYPE: 'type',
    TRIM_SIZE: 'trimSize',
    COLOR: 'resourceColorSetting',
    DESCRIPTION: 'description',
    SINGLE_COLOR: 'SingleColor',
    BLACK_WHITE: 'Black and White',
    FOUR_COLOR: 'Color',
    INSERT_AFTER: 'insertAfter'
};
export const BINDING_TYPES = [
    {
        code: 'BT_P',
        name: 'Perfect',
        label: 'bindingTypes.perfect.label',
        imagePath: '../../../assets/printadmin/images/Perfect.png',
        description: 'bindingTypes.perfect.description'
    },
    {
        code: 'BT_SWL_3H',
        name: 'Looseleaf 3-hole drill',
        label: 'bindingTypes.looseLeaf.label',
        imagePath: '../../../assets/images/Looseleaf_BR.png',
        description: 'bindingTypes.looseLeaf.description'
    },
    {
        code: 'BT_P_3H',
        name: 'Perfect 3-hole drill',
        label: 'bindingTypes.perfectBinderReady.label',
        imagePath: '../../../assets/images/Perfect_BR.png',
        description: 'bindingTypes.perfectBinderReady.description'
    },
    {
        code: 'BT_PC',
        name: 'Plastic Coil',
        label: 'bindingTypes.plasticCoil.label',
        imagePath: '../../../assets/images/Coil.png',
        description: 'bindingTypes.plasticCoil.description'
    },
    {
        code: 'BT_PC_3H',
        name: 'Plastic Coil 3-hole drill'
    }
];

export const PAPER_TYPES = [
    {code: 'PT_STD', name: 'Standard'},
    {code: 'PT_PRF', name: 'Perforation'}
];

export const PAPER_WEIGHTS = [
    {
        code: 'PW_45',
        name: '45lbs'
    },
    {
        code: 'PW_50',
        name: '50lbs'
    },
    {
        code: 'PW_60',
        name: '60lbs Opus Satin'
    },
    {
        code: 'PW_30',
        name: '30lbs matte'
    }
];
   
export const PERMISSIONS = {
    view_only_notes: 'view_only_notes',
    view_only_collection_title : 'view_only_collection_title',
    view_only_print_type : 'view_only_print_type',
    view_only_toc_numeration : 'view_only_toc_numeration',
    view_only_print_book_price : 'view_only_print_book_price',
    view_only_page_numbering : 'view_only_page_numbering',
    view_only_automated_indexes : 'view_only_automated_indexes',
    view_only_forced_recto : 'view_only_forced_recto',
    view_only_binding_type : 'view_only_binding_type',
    view_only_paper_type : 'view_only_paper_type',
    view_only_paper_weight : 'view_only_paper_weight',
    view_only_instructor_change : 'view_only_instructor_change',
    view_only_institution_change : 'view_only_institution_change',
    view_only_desk_copies : 'view_only_desk_copies',
    view_only_institute : 'view_only_institute',
    view_only_department : 'view_only_department',
    view_only_instructor : 'view_only_instructor',
    view_only_instructor2 : 'view_only_instructor2',
    view_only_address1 : 'view_only_address1',
    view_only_address2 : 'view_only_address2',
    view_only_address3 : 'view_only_address3',
    view_only_city : 'view_only_city',
    view_only_zip_code : 'view_only_zip_code',
    view_only_country : 'view_only_country',
    view_only_state : 'view_only_state',
    view_only_org_unit : 'view_only_org_unit',
    view_only_course_name : 'view_only_course_name',
    view_only_course_number : 'view_only_course_number',
    view_only_term : 'view_only_term',
    view_only_class_startdate : 'view_only_class_startdate',
    view_only_add_frontmatter : 'view_only_add_frontmatter',
    hide_add_om : 'hide_add_om',
    hide_add_content : 'hide_add_content',
    view_only_page_divider : 'view_only_page_divider',
    view_only_delete_chapter : 'view_only_delete_chapter',
    view_only_draggable : 'view_only_draggable',
    view_only_table_draggable : 'view_only_table_draggable',
    view_only_om_title : 'view_only_om_title',
    view_only_om_download  : 'view_only_om_download',
    view_only_rebuild_book :'view_only_rebuild_book',
    view_only_save_change :'view_only_save_changes',
    view_only_send_to_pdh :'view_only_send_to_pdh',
    view_only_view_pdh_log:'view_only_view_pdh_log',
    view_only_send_to_pitstop:'view_only_send_to_pitstop',
    view_only_send_to_printer:'view_only_send_to_printer',
    view_only_cancel_order:'view_only_cancel_order',
    view_only_bundle_add:'view_only_bundle_add',
    view_only_bundle_isbn:'view_only_bundle_isbn',
    view_only_bundle_notes:'view_only_bundle_notes',
    view_only_cover_title:'view_only_cover_title',
    view_only_cover_subtitle:'view_only_cover_subtitle',
    view_only_cover_author:'view_only_cover_author',
    view_only_cover_other:'view_only_cover_other',
    view_only_cover_design:'view_only_cover_design',
    view_only_delete_part: 'view_only_delete_part',
    hide_adding_part: 'hide_adding_part',
    view_only_part_title: 'view_only_part_title',
    hide_only_pdflinks:'hide_only_pdflinks',
};




// WEBPACK FOOTER //
// ./src/components/constants/constants.js